import Modal from "components/DesignSystem/Modal/Modal";
import { AuditlogList } from "components/AuditlogList/AuditlogList";
import { CrmField } from "types/Models/crmFields";

/** History for one CRM field's value on one entity - opened from the field's "..." menu. */
export const CRMFieldAuditLogModal = ({
  isOpen,
  close,
  entityId,
  field,
}: {
  isOpen: boolean;
  close: () => void;
  entityId: string;
  field?: CrmField | null;
}) => (
  <Modal.Root open={isOpen} onOpenChange={close}>
    <Modal.Content>
      <Modal.Header>
        <Modal.Title>{field?.label} audit log</Modal.Title>
        <Modal.Close />
      </Modal.Header>
      <Modal.Body>
        {field?.value_uuid ? (
          <AuditlogList entityId={entityId} objectId={field.value_uuid} />
        ) : (
          <div className="t-text-body-sm t-text-text-30">
            No history yet - this field has never been set.
          </div>
        )}
      </Modal.Body>
    </Modal.Content>
  </Modal.Root>
);
